import InventoryIcon from '@material-ui/icons/Extension';
import { APP_TYPES, roles } from '../../../config/constants';
import ScheduleList from '../ScheduleList';

const options = {
  appTypes: [APP_TYPES.ALL],
  allowedRoles: [roles.ADMIN, roles.BA, roles.JTI_TEAM, roles.RSM, roles.USER],
  label: 'Digital Products',
  subMenuName: 'scheduleList',
};

export default {
  list: ScheduleList,
  icon: InventoryIcon,
  name: 'admin/schedule/type/product',
  options,
};
